import React from 'react';
import { Trophy, Globe, Award, Users } from 'lucide-react';
import { Card } from './ui/card';

const Experience = () => {
  const achievements = [
    {
      year: '1998-2017',
      title: 'Competitive Career',
      description: 'Represented Bulgaria at international competitions for nearly two decades'
    },
    {
      year: '6 Times',
      title: 'Bulgarian National Champion',
      description: 'Dominated the national championship throughout competitive career'
    },
    {
      year: '2001',
      title: 'European Championships',
      description: 'Best result: 16th place, reached free skate at four ISU Championships'
    },
    {
      year: '2017-Present',
      title: 'Professional Coaching',
      description: 'Successfully coaching and choreographing for competitive skaters'
    }
  ];

  const coaches = [
    'Ludmila Mladenova',
    'Rafael Arutyunyan',
    'Naiden Borichev',
    'Kent Johnson'
  ];

  const competitions = [
    { name: 'European Championships', count: 'Multiple appearances' },
    { name: 'World Championships', count: 'Competed at elite level' },
    { name: 'World Junior Championships', count: 'Early career success' },
    { name: 'ISU Championships', count: 'Reached free skate 4 times' }
  ];

  return (
    <section id="experience" className="py-24 bg-slate-800">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-amber-600 text-white rounded-full text-sm font-semibold mb-6">
            Experience & Achievements
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            A Legacy of Excellence
          </h2>
          <p className="text-xl text-slate-300">
            Two decades of international competition experience now dedicated to developing future champions.
          </p>
        </div>

        {/* Timeline */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {achievements.map((achievement, index) => (
            <Card key={index} className="p-6 bg-slate-700 border-slate-600 hover:border-amber-400 hover:shadow-lg transition-all duration-300">
              <div className="text-3xl font-bold text-amber-400 mb-3">
                {achievement.year}
              </div>
              <h3 className="text-xl font-bold text-white mb-2">
                {achievement.title}
              </h3>
              <p className="text-slate-300">
                {achievement.description}
              </p>
            </Card>
          ))}
        </div>

        {/* Two Column Layout */}
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Elite Training Background */}
          <Card className="p-8 bg-slate-700 border-slate-600">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-sky-600 p-3 rounded-lg">
                <Users className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-white">
                Elite Training Background
              </h3>
            </div>
            <p className="text-slate-300 mb-6">
              Trained by some of the most respected coaches in figure skating, bringing world-class expertise to every lesson.
            </p>
            <div className="space-y-3">
              {coaches.map((coach, index) => (
                <div key={index} className="flex items-center">
                  <div className="w-2 h-2 bg-sky-400 rounded-full mr-3"></div>
                  <span className="text-slate-300 font-medium">{coach}</span>
                </div>
              ))}
            </div>
          </Card>

          {/* International Competition Record */}
          <Card className="p-8 bg-slate-700 border-slate-600">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-amber-600 p-3 rounded-lg">
                <Globe className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-white">
                International Competition Record
              </h3>
            </div>
            <p className="text-slate-300 mb-6">
              Extensive experience competing at the highest levels of international figure skating.
            </p>
            <div className="space-y-4">
              {competitions.map((comp, index) => (
                <div key={index} className="flex justify-between items-center">
                  <span className="text-slate-300 font-medium">{comp.name}</span>
                  <span className="text-sm text-slate-400">{comp.count}</span>
                </div>
              ))}
            </div>
          </Card>
        </div>

        {/* Stats Bar */}
        <div className="mt-16 bg-gradient-to-r from-sky-600 to-sky-500 rounded-2xl p-8 text-white">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">19</div>
              <div className="text-sky-100">Years Competing</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">6</div>
              <div className="text-sky-100">National Titles</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">4</div>
              <div className="text-sky-100">ISU Free Skates</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">8+</div>
              <div className="text-sky-100">Years Coaching</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;